import { createSlice } from '@reduxjs/toolkit';
import type {PayloadAction} from "@reduxjs/toolkit"
import ActionManager from '../../classes/ActionManager';

export interface IActionData {
	id: number;
	name: string;
	index:number;
}

export interface IHistoryState {
	actionHistory: IActionData[],
	currentActionIndex: number,
	currentActionId: number,
	isSaveDirty: boolean,
	lastSavedActionId: number,
	lastDirtyActionId: number,
}

const initialState: IHistoryState = {
	actionHistory: [],
	currentActionIndex: -1,
	currentActionId: -1,
	isSaveDirty: false,
	lastSavedActionId: -1,
	lastDirtyActionId: -1,
};

const HistorySlice = createSlice({
	name: "history",
	initialState,
	reducers: {
		setActionHistoryStack(state, action: PayloadAction<IActionData[]>) 
		{
			state.actionHistory = action.payload.map((action, index) =>
			{
				return {
					id: action.id,
					name: action.name,
					index: index
				};
			});
		},
		setCurrentAction(state, action: PayloadAction<{ id: number, index: number}>)
		{
			state.currentActionIndex = action.payload.index;
			state.currentActionId = action.payload.id;
			const currentAction = ActionManager.actionStack[ActionManager.currentActionIndex];
			const actionDirty = currentAction?.isDirtyAction;
			if (actionDirty)
			{
				state.lastDirtyActionId = currentAction.id;
			}
			else 
			{
				let lastDirtyActionId = -1;
				for (let i = 0; i < ActionManager.currentActionIndex; i++)
				{
					const action = ActionManager.actionStack[i];
					if (action?.isDirtyAction)
					{
						lastDirtyActionId = action.id;
					}
				}
				state.lastDirtyActionId = lastDirtyActionId;
			}
			state.isSaveDirty = state.lastDirtyActionId !== state.lastSavedActionId;
		},
		clearDirtyAction(state)
		{
			state.lastDirtyActionId = -1;
			state.lastSavedActionId = -1;
			state.isSaveDirty = false;
		},
		onProjectSaved(state)
		{
			state.lastSavedActionId = state.lastDirtyActionId;
			state.isSaveDirty = false;
		},
	},
});

export default HistorySlice;
